import style from "./index.module.css";
import { useState } from "react";
import arrow_down from "../../assets/images/icons/arrow-down.svg";
const EducationDropDown = ({data}) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const open = (item) => {
      if (selectedItem === item) {
        setSelectedItem(null);
        return;
      }
      setSelectedItem(item);
    };
  return (
    <div className={style.accordion}>
      <div className={style.left}>
        {data.slice(0, Math.floor(data.length / 2)).map((item, index) => (
          <div className={style.card}>
            <div className={style.head} onClick={() => open(item)}>
              <h1>{item.titile}</h1>
              <img
                className={selectedItem === item && style.rotate}
                src={arrow_down}
                alt=""
              />
            </div>
            <h2 className={selectedItem === item ? style.visible : style.body}>
              <p>·</p>{item.body.map(item => item.text)}
            </h2>
          </div>
        ))}
      </div>
      <div className={style.right}>
        {data.slice(Math.floor(data.length / 2)).map((item, index) => (
          <div className={style.card}>
            <div className={style.head} onClick={() => open(item)}>
              <h1>{item.titile}</h1>
              <img
                className={selectedItem === item && style.rotate}
                src={arrow_down}
                alt=""
              />
            </div>
            <h2 className={selectedItem === item ? style.visible : style.body}>
            <p>·</p>{item.body}
            </h2>
          </div>
        ))}
      </div>
    </div>
  );
};
export default EducationDropDown;

{
  /* <li><Link to="https://www.youtube.com/watch?v=FfQioJDOYwo">
    Обзор HRM платформы PeopleForce - лучший функционал и
    лучший дизайн 🔥HRM прожарка🔥
</Link></li> */
}
